import  * as React from "react";
import { observer } from "mobx-react";
import { action } from "mobx";
import {IStrokesGroupButtonProps} from "./IStrokesGroupButtonProps";
import { ITagsListParams } from "./../MultiShotControl/TagsList/ITagsListParams";
import { SwitchButton, TagsList} from "Components";
import { ReportKind } from "Data";
import { TargetsHelper } from "MeasurementsCalculations";

@observer
export class StrokesGroupButton extends React.Component<IStrokesGroupButtonProps> {
    constructor(props: IStrokesGroupButtonProps) {
        super(props, undefined);
    }
    @action.bound
    displayStrokesGroup() {
        this.props.displayStrokesGroup(this.props.groupIndex);
    }

    render() {
        let isSingleOrMultiOrPuttingSingleOrPuttingMultiReport =
            (this.props.reportKind === ReportKind.multiGroupReport ||
                this.props.reportKind === ReportKind.singleGroupReport ||
                this.props.reportKind === ReportKind.puttingMultiGroupReport ||
                this.props.reportKind === ReportKind.puttingSingleGroupReport);
        let isDrShotAnalysis = this.props.reportKind === ReportKind.drShotAnalysis;
        let isCompareOrPuttingCompareOrSingleShotOrPuttingSingleShotReport = (this.props.reportKind ===
            ReportKind.singleShotReport || this.props.reportKind === ReportKind.puttingSingleShotReport || this.props.reportKind === ReportKind.compareReport || this.props.reportKind === ReportKind.puttingCompareReport);
        let isCombineOrTestCenterReport = (this.props.reportKind === ReportKind.combineTestReport ||
            this.props.reportKind === ReportKind.testCenterReport);
        let displayedAverageScore = this.props.measurementGroup.averageScore != null
            ? this.props.measurementGroup.averageScore.toFixed(1)
            : this.props.measurementGroup.averageScore;
        let targetInUnits = TargetsHelper.targetInUnits(this.props.measurementGroup, this.props.selectedUnit);
        return <div>
            {(isSingleOrMultiOrPuttingSingleOrPuttingMultiReport || isDrShotAnalysis) &&
                <div className="StrokesGroupButton strokes-btn-wrapper" onClick={() => this.displayStrokesGroup()}>
                    <SwitchButton measurementGroup={this.props.measurementGroup}
                        groupIndex={this.props.groupIndex} />
                    <TagsList {...this.getTagsListParams() } />
                    <div className="shots-and-ball">
                        <div className="shots-number">
                            <div className="ball-icon">
                                <img src="Images/MultiGroupReport/single-shot-icon-without-border.png" alt="Ball icon" /><span>{
                                    this.props?.measurementGroup?.strokes?.length ?? 0}</span>
                            </div>
                        </div>
                        {this.props.measurementGroup.date &&
                            <div className="date-text">
                                <span>{this.props.measurementGroup.date}</span>
                            </div>
                        }
                    </div>
                </div>
            }
            {isCompareOrPuttingCompareOrSingleShotOrPuttingSingleShotReport &&
                <div className={`StrokesGroupButton strokes-btn-wrapper single-shot ${this.props.reportKind}`} >
                    <div className="circle-with-club">
                        <div className="club-type-wrapper" style={{ borderColor: this.props.measurementGroup.color, left: '1px' }}>
                            <span className="abbreviated-club-type-text" style={{ color: this.props.measurementGroup.isSelected ? this.props.measurementGroup.color : '#c1c1c1' }}>{this.props.measurementGroup.abbreviatedClubType}</span>
                        </div>
                    </div>
                <div className={`tag-list ${this.props.reportKind}`}>
                        {this.props.measurementGroup.tagsTitle !== "" &&
                            <span>{this.props.measurementGroup.tagsTitle}</span>
                        }
                        {this.props.measurementGroup.tagsTitle === "" &&
                            <span>{this.props.measurementGroup.clubType}</span>
                        }
                    </div>

                    <div className="shots-and-ball">
                        <div className="shots-number">
                            <div className="ball-icon">
                                <img src="Images/MultiGroupReport/single-shot-icon-without-border.png" alt="Ball icon" /><span>{
                                    this.props?.measurementGroup?.strokes?.length ?? 0}</span>
                            </div>
                        </div>
                        {this.props.measurementGroup.date &&
                            <div className="date-text">
                                <span>{this.props.measurementGroup.date}</span>
                            </div>
                        }
                    </div>
                </div>
            }
            {isCombineOrTestCenterReport &&
                <div className={`StrokesGroupButton strokes-btn-wrapper ${this.props.reportKind}`} onClick={() => this.displayStrokesGroup()} style={{ borderColor: this.props.reportKind === ReportKind.testCenterReport && this.props.measurementGroup.isSelected ? this.props.measurementGroup.color : '#c1c1c1' }}>
                    <span className="switch-wrapper">
                        <span className="switch-background" style={{ backgroundColor: this.props.measurementGroup.isSelected ? this.props.measurementGroup.color : '#c1c1c1' }}></span>
                        <span className="club-type-wrapper" style={{ left: this.props.measurementGroup.isSelected ? '20px' : '1px' }} >
                        </span>
                    </span>
                    <div className="target-and-score-button-wrapper">
                        <div className="target-wrapper">
                            <p>Target</p>
                            <p className="target-details">
                            <span className="target-in-units">{targetInUnits} </span>
                            {targetInUnits !== "Drive" && targetInUnits !== "Junior L1" && targetInUnits !== "Junior L2" && targetInUnits !== "Junior L3" &&
                                    <span className="target-units">{this.props.selectedUnit === 'u' ? 'yds' : 'm'}</span>
                                }
                            </p>
                        </div>
                        <div className="score-wrapper">
                            <p className="score-text">Score</p>
                            <p className="score" data-bind="text: averageScore != null ? averageScore.toFixed(1): averageScore">{displayedAverageScore}</p>
                        </div>
                    </div>
                </div>
            }
        </div>;
    }

    private getTagsListParams() {
        const result: ITagsListParams = {
            measurementGroup: this.props.measurementGroup,
            unitPresentation: this.props.unitPresentation
        };
        return result;
    }
}
